import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { earningList } from "../apis/apiHandler";

export const earning = createAsyncThunk(
    "Earning/list",
    async (payload, { rejectWithValue }) => {
        try {
            console.log("Earning API Request:", payload);
            const response = await earningList(payload);
            console.log("Earning API Response:", response);

            if (response?.code === 1 || response?.code === 2) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("Earning API Error:", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    earningList: [],
    error: null,
    success: false,
};

const earningSlice = createSlice({
    name: "earning",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(earning.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(earning.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.earningList = payload;
                state.success = true;
            })
            .addCase(earning.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            });
    },
});

export default earningSlice.reducer;
